import React from 'react';
import { Stack } from '@mui/material';
import TitleTooltip from 'common/TitleTooltip/TitleTooltip';
import { useTranslation } from 'react-i18next';

interface TooltipIconProps {
  label: string;
  children: React.ReactNode;
}

export default function TooltipIcon({ label, children }: TooltipIconProps) {
  const { t } = useTranslation();

  return (
    <TitleTooltip title={t(label)}>
      <Stack alignItems="center" justifyContent="center">
        {children}
      </Stack>
    </TitleTooltip>
  );
}
